var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ConfirmRegister"},[(_vm.loading)?_c('div',[_vm._v("\n    Верификация на акаунта\n    "),_c('v-icon',{staticClass:"mps-pulse",attrs:{"type":"refresh"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }